import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import FormatCurrency from '../FormatCurrency'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import TextLink from 'components/Luxkit/TextLink'
import SolidInfoCircleIcon from 'components/Luxkit/Icons/solid/SolidInfoCircleIcon'
import useToggle from 'hooks/useToggle'
import PayInInstalmentsMoreInfoModal from '../PayInInstalmentsInfo/PayInInstalmentsMoreInfoModal'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledLink = styled(TextLink)`
  &.icon-left >:first-child {
    margin-right: ${rem(0)};
  }
`

interface Props {
  currency: string;
  isOfferSummary?: boolean;
  depositPercentage: number;
  instalmentAmount: number;
  cancellationPolicy?: App.OfferCancellationPolicy;
  checkInDate?: moment.Moment;
  propertyTimezoneOffset?: number;
}

function SecureWithFlexiblePaymentsPriceDetails(props: Props) {
  const {
    currency,
    isOfferSummary = false,
    depositPercentage,
    instalmentAmount,
    cancellationPolicy,
    checkInDate,
    propertyTimezoneOffset,
  } = props

  const [showModal, _, openModal, onCloseModal] = useToggle(false)

  return (
    <Wrapper>
      {!isOfferSummary &&
        <BodyText variant="small" colour="neutral-two">
          from <FormatCurrency currency={currency} value={instalmentAmount} />/week&nbsp;
        </BodyText>
      }
      {isOfferSummary &&
        <BodyText variant="small" colour="neutral-two">
          or from&nbsp;
          <BodyText as="span" variant="small" weight="bold" colour="neutral-two"><FormatCurrency currency={currency} value={instalmentAmount} /></BodyText>
          <BodyText as="span" variant="small" colour="neutral-two">/week&nbsp;</BodyText>
        </BodyText>
      }
      <Wrapper role="presentation" onClick={stopPropagation}>
        <StyledLink size="small" startIcon={<SolidInfoCircleIcon colour="primary" />} onClick={openModal}/>
      </Wrapper>
      <PayInInstalmentsMoreInfoModal
        isPolicyOpen={showModal}
        closePolicy={onCloseModal}
        depositPercentage={depositPercentage}
        cancellationPolicy={cancellationPolicy}
        checkInDate={checkInDate}
        propertyTimezoneOffset={propertyTimezoneOffset} />
    </Wrapper>
  )
}

export default SecureWithFlexiblePaymentsPriceDetails
